import { render, staticRenderFns } from "./totalAdvert.vue?vue&type=template&id=3cb7427e&scoped=true&"
import script from "./totalAdvert.vue?vue&type=script&lang=js&"
export * from "./totalAdvert.vue?vue&type=script&lang=js&"
import style0 from "./totalAdvert.vue?vue&type=style&index=0&id=3cb7427e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb7427e",
  null
  
)

export default component.exports